import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./store/index";
import "./assets/css/App.css";
import App from "./App";
import { BrowserRouter, Routes, Route } from "react-router-dom";

const el = document.getElementById("root");
const root = createRoot(el);

root.render(
    <React.StrictMode>
        <Provider store={store}>
            <BrowserRouter>
                <Routes>
                    <Route path="/*" element={<App />} />
                </Routes>
            </BrowserRouter>
        </Provider>
    </React.StrictMode>
);
